<template>
    <b-container>
    <transition-group name="fade" tag="b-row">
    <purifier-view v-for="(purifier, index) in purifiers" v-bind:purifier="purifier" v-bind:index="index" v-bind:key="purifier.id"></purifier-view>
    </transition-group>
    </b-container>
</template>

<script>
// looks
// speed
// what can it filter?
import PurifierView from '@/components/PurifierView'

export default {
  components: {PurifierView},
  name: 'SelectorView',
  props: {
    purifiers: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
a h1, a h2, a:hover {
  text-decoration:none;
  color: #2c3e50;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
img.purifier_img {
  max-width:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectorView.vue